import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from 'react-moment';
import limparUltimosHIstoricosRota from '../../actions/rota/limparUltimosHIstoricosRota';
import capitalizarTodasPrimeirasLetras from '../../util/capitalizarTodasPrimeirasLetras';

export const Cabecalho = () => (
    <thead>
      <tr>
        <th>Data e Hora</th>
        <th>Situação</th>
        <th>Usuário</th>
        <th>Prefixo</th>
        <th>Delimitação</th>
        <th>Cidade Origem</th>
        <th>Cidade Destino</th>
        <th>Trecho Alt.</th>
      </tr>
    </thead>
  );
  

export class ModalHistoricoRota extends Component {    

    fecharModal () {
        $('#modalHistoricoRota').modal('hide');
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');
        this.props.limparUltimosHIstoricosRota();
    }

    exibirHistoricos() {
        if (this.props.historicos && this.props.historicos.length) {
          return this.props.historicos.map(historico => (
            <tr key={`${historico.id}-${historico.dataEvento}`}>
              <td><Moment format="DD/MM/YYYY HH:mm">{historico.dataEvento}</Moment></td>
              <td>{capitalizarTodasPrimeirasLetras(historico.tipoEvento)}</td>
              <td>{capitalizarTodasPrimeirasLetras(historico.responsavel.nome)}</td>
              <td>{historico.rota.prefixo}</td>
              <td>{historico.rota.delimitacao}</td>
              <td>{historico.rota.cidadeOrigem.nomeComUf}</td>
              <td>{historico.rota.cidadeDestino.nomeComUf}</td>
              <td>{historico.rota.opcoesTrechoAlternativo ? 'Sim' : 'Não'}</td>
            </tr>
          ))
        }
        return null
      }

      render() {
        return (
            <div className="modal fade show" id="modalHistoricoRota" role="dialog"
                aria-labelledby="modalHistoricoRota" aria-hidden="true" data-backdrop="static">
              <div className="modal-dialog modal-dialog-centered modal-xl">
                <div className="modal-content" style={{ borderRadius: 12, overflow: 'hidden', border: 'none' }}>
                  <div className="vx-modal-header">
                    <div className="vx-modal-title">
                      <span className="material-icons">history</span>
                      Histórico Rota{this.props.rotaSelecionada ? ` — ${this.props.rotaSelecionada.id}` : ''}
                    </div>
                    <button type="button" className="vx-modal-close" data-dismiss="modal" aria-label="Close"
                        onClick={() => this.fecharModal()}>
                      <span className="material-icons">close</span>
                    </button>
                  </div>
                  <div className="vx-modal-body">
                    <div className="table-responsive">
                      <table className="table table-sm table-striped table-bordered" style={{ fontSize: 13 }}>
                        <Cabecalho />
                        <tbody>
                          {this.exibirHistoricos()}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="vx-modal-footer">
                    <button type="button" className="vx-modal-btn-fechar"
                        data-dismiss="modal" onClick={() => this.fecharModal()}>
                      Fechar
                    </button>
                  </div>
                </div>
              </div>
            </div>
        )
    }
}

export const mapStateToProps = (state) => {
    return {
        rotaSelecionada: state.rotaSelecionada,
        empresaSelecionada: state.empresaSelecionada,
        historicos: state.ultimosHistoricosRota
    }
};

export default connect(mapStateToProps, {
    limparUltimosHIstoricosRota
})(ModalHistoricoRota)